document.addEventListener('DOMContentLoaded', function() {
  const header = document.querySelector('header.header');
  const megaMenu = document.querySelector("div.meteor-menu");
    console.log('header ' + header);
      console.log('megaMenu ' + megaMenu);
  // Function to get and log the element's height
  function updateElementHeight() {
     if (!header || !megaMenu) return;
    
    const height = header.offsetHeight; 
    console.log('Current height:', height + 'px');
    
    megaMenu.style.setProperty('top', height + 'px', 'important');
  }

  updateElementHeight();

  window.addEventListener('resize', function() {
      updateElementHeight();
  });
});